module.exports = __webpack_public_path__ + "static/media/settings.cf8c427c.svg";